// extracted by mini-css-extract-plugin
export default {"cardContainer":"sessionNew_cardContainer__pWe7+","showCard":"sessionNew_showCard__p2UBo","editStyle":"sessionNew_editStyle__p9Rxs","font20":"sessionNew_font20__s2hdS"};